import { IUserDto } from 'entities/Users/Users.models';

export const getUsersOptions = (data?: IUserDto[]) => {
  return data?.map((item) => ({ value: item.id, label: item.name }));
};
